import { Client } from "@/types/client.ts";

export interface SignupQuestion {
  label: string;
  options: string[];
  required: boolean;
}

// The question is only shown when it has a label and at least one option.
// The cached client in localStorage may predate these fields, hence `?.`.
export const getSignupQuestion = (
  client: Client | null,
): SignupQuestion | null => {
  if (!client?.signup_question || !client.signup_question_options?.length) {
    return null;
  }
  return {
    label: client.signup_question,
    options: client.signup_question_options,
    required: client.signup_question_required,
  };
};
